// import { useState, useEffect } from 'react';
// import { Award } from 'lucide-react';

// export default function QProcess() {
//   // Animation states
//   const [activeStepIndex, setActiveStepIndex] = useState(-1);
//   const [circleAnimated, setCircleAnimated] = useState(false);
//   const [titleAnimated, setTitleAnimated] = useState(false);
//   const [restartAnimation, setRestartAnimation] = useState(false);
  
//   // Sequential animation
//   useEffect(() => {
//     // Initial animation
//     runFullAnimation();
    
//     // Set up continuous animation every 8 seconds
//     const intervalId = setInterval(() => {
//       runFullAnimation();
//     }, 8000);
    
//     return () => clearInterval(intervalId);
//   }, []);
  
//   // Function to run full animation sequence
//   const runFullAnimation = () => {
//     // Reset everything
//     setActiveStepIndex(-1);
//     setCircleAnimated(false);
//     setTitleAnimated(false);
//     setRestartAnimation(prev => !prev); // Toggle to restart animations
    
//     // Start sequence again
//     setTimeout(() => setTitleAnimated(true), 300);
//     setTimeout(() => setCircleAnimated(true), 800);
    
//     // Steps animation - sequentially
//     const stepDelay = 1300;
    
//     steps.forEach((_, index) => {
//       setTimeout(() => {
//         setActiveStepIndex(index);
//       }, stepDelay + (index * 300)); // Each step appears after 300ms delay
//     });
//   };
  
//   // Styles
//   const qualityProcessSection = {
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'space-between',
//     gap: '40px',
//     flexWrap: 'wrap',
//     padding: '20px',
//     maxWidth: '1000px',
//     margin: '0 auto',
//     fontFamily: 'system-ui, sans-serif',
//   };
  
//   const titleSection = {
//     opacity: titleAnimated ? 1 : 0,
//     transform: titleAnimated ? 'translateY(0)' : 'translateY(20px)',
//     transition: 'all 0.6s ease-out',
//   };
  
//   const policyHeader = {
//     fontSize: '2.5rem',
//     color: '#003366',
//     fontWeight: 'bold',
//     lineHeight: '1.2',
//     margin: '0 0 20px 0',
//   };
  
//   // Circle with continuous animation
//   const circleWrapper = {
//     width: '160px',
//     height: '160px',
//     borderRadius: '50%',
//     backgroundColor: '#e6f0fa',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
//     border: '4px solid #003366',
//     opacity: circleAnimated ? 1 : 0,
//     transform: circleAnimated ? 'scale(1) rotate(0deg)' : 'scale(0.5) rotate(-45deg)',
//     transition: 'all 0.7s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
//     position: 'relative',
//     overflow: 'hidden',
//   };
  
//   // Pulsing background effect
//   const pulsingCircleStyle = {
//     position: 'absolute',
//     top: '0',
//     left: '0',
//     width: '100%',
//     height: '100%',
//     borderRadius: '50%',
//     background: 'radial-gradient(circle, rgba(255,255,255,0.7) 0%, rgba(230,240,250,0) 70%)',
//     animation: circleAnimated ? 'pulse 2s infinite' : 'none',
//   };
  
//   // Rotating outer ring effect
//   const rotatingRingStyle = {
//     position: 'absolute',
//     top: '-10px',
//     left: '-10px',
//     right: '-10px',
//     bottom: '-10px',
//     border: '2px dashed #003366',
//     borderRadius: '50%',
//     opacity: 0.4,
//     animation: circleAnimated ? 'rotate 8s linear infinite' : 'none',
//   };
  
//   const qualityProcessWrapper = {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '12px',
//     minWidth: '300px',
//     flex: 1,
//   };
 
//   const qualityStep = {
//     backgroundColor: '#003366',
//     color: 'white',
//     padding: '12px 25px',
//     borderRadius: '50px',
//     fontSize: '15px',
//     fontWeight: '500',
//     boxShadow: '0 3px 6px rgba(0, 0, 0, 0.1)',
//     transition: 'all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
//     cursor: 'pointer',
//     whiteSpace: 'nowrap',
//     textAlign: 'center',
//   };

//   // Step hover effect
//   const [hoveredStep, setHoveredStep] = useState(null);
  
//   // Animation delays for steps
// //   const steps = [
// //     { text: 'Production Plan Approval Process', marginLeft: '0px',color: '#ff7800' },
// //     { text: 'PPAP New Parts', marginLeft: '30px' },
// //     { text: 'Control Plan', marginLeft: '50px' },
// //     { text: 'Failure Mode Effect Analysis', marginLeft: '60px' },
// //     { text: 'Poke Yoke', marginLeft: '80px' },
// //     { text: 'Statistical Process Control', marginLeft: '60px' },
// //     { text: '8D Approach Problem Solving', marginLeft: '50px' },
// //     { text: 'Final Inspection', marginLeft: '30px' },
// //     { text: 'Total Quality Maintenance', marginLeft: '0px' },
// //   ];
// const steps = [
//     { text: 'Production Plan Approval Process', marginLeft: '0px', color: '#ff7800' }, // orange
//     { text: 'PPAP New Parts', marginLeft: '30px', color: '#1E3A8A' }, // blue
//     { text: 'Control Plan', marginLeft: '50px', color: '#ff7800' }, 
//     { text: 'Failure Mode Effect Analysis', marginLeft: '60px', color: '#1E3A8A' },
//     { text: 'Poke Yoke', marginLeft: '80px', color: '#ff7800' },
//     { text: 'Statistical Process Control', marginLeft: '60px', color: '#1E3A8A' },
//     { text: '8D Approach Problem Solving', marginLeft: '50px', color: '#ff7800' },
//     { text: 'Final Inspection', marginLeft: '30px', color: '#1E3A8A' },
//     { text: 'Total Quality Maintenance', marginLeft: '0px', color: '#ff7800' },
//   ];
  

//   return (
//     <div style={qualityProcessSection}>
//       {/* CSS for animations */}
//       <style>
//         {`
//           @keyframes pulse {
//             0% { transform: scale(0.95); opacity: 0.7; }
//             50% { transform: scale(1.05); opacity: 0.9; }
//             100% { transform: scale(0.95); opacity: 0.7; }
//           }
          
//           @keyframes rotate {
//             0% { transform: rotate(0deg); }
//             100% { transform: rotate(360deg); }
//           }
          
//           @keyframes fadeInOut {
//             0% { opacity: 0; transform: translateX(-40px); }
//             10% { opacity: 1; transform: translateX(0); }
//             90% { opacity: 1; transform: translateX(0); }
//             100% { opacity: 0; transform: translateX(-40px); }
//           }
//         `}
//       </style>
    
//       <div style={titleSection} key={`title-${restartAnimation}`}>
//         <h2 style={policyHeader}>Quality <br/> Process</h2>
//       </div>
      
//       <div style={circleWrapper} key={`circle-${restartAnimation}`}>
//         <div style={rotatingRingStyle}></div>
//         <div style={pulsingCircleStyle}></div>
//         <Award size={60} color="#003366" strokeWidth={1.5} />
//       </div>
      
//       <div style={qualityProcessWrapper}>
//   {steps.map((step, index) => {
//     const baseColor = step.color || '#003366'; // fallback
//     const hoverColor = baseColor === '#ff7800' ? '#cc5e00' : '#0055a4'; // slightly darker orange/blue

//     return (
//       <div 
//         key={`${index}-${restartAnimation}`}
//         style={{
//           ...qualityStep,
//           marginLeft: step.marginLeft,
//           opacity: index <= activeStepIndex ? 1 : 0,
//           transform: index <= activeStepIndex 
//             ? (hoveredStep === index ? 'translateX(10px) scale(1.05)' : 'translateX(0)')
//             : 'translateX(-40px)',
//           backgroundColor: hoveredStep === index ? hoverColor : baseColor,
//           boxShadow: hoveredStep === index 
//             ? '0 6px 12px rgba(0, 0, 0, 0.15)' 
//             : '0 3px 6px rgba(0, 0, 0, 0.1)',
//           color: 'white',
//           padding: '10px 20px',
//           borderRadius: '0 50px 50px 0',
//           width: 'fit-content',
//           fontWeight: 'bold',
//           transition: 'all 0.3s ease',
//         }}
//         onMouseEnter={() => setHoveredStep(index)}
//         onMouseLeave={() => setHoveredStep(null)}
//       >
//         {step.text}
//       </div>
//     );
//   })}
// </div>

//     </div>
//   );
// }


// import { useState, useEffect, useCallback } from 'react';
// import { Award } from 'lucide-react';
// import { FcProcess } from "react-icons/fc";

// export default function QualityProcess() {
//   // Animation states
//   const [activeStepIndex, setActiveStepIndex] = useState(-1);
//   const [circleAnimated, setCircleAnimated] = useState(false);
//   const [titleAnimated, setTitleAnimated] = useState(false);
//   const [restartAnimation, setRestartAnimation] = useState(false);
  
//   // Sequential animation
//   useEffect(() => {
//     // Initial animation
//     runFullAnimation();
    
//     // Set up continuous animation every 8 seconds
//     const intervalId = setInterval(() => {
//       runFullAnimation();
//     }, 8000);
    
//     return () => clearInterval(intervalId);
//   }, []);
  
//   // Function to run full animation sequence - memoized with useCallback
//   const runFullAnimation = useCallback(() => {
//     // Reset everything
//     setActiveStepIndex(-1);
//     setCircleAnimated(false);
//     setTitleAnimated(false);
//     setRestartAnimation(prev => !prev); // Toggle to restart animations
    
//     // Start sequence again
//     setTimeout(() => setTitleAnimated(true), 300);
//     setTimeout(() => setCircleAnimated(true), 800);
    
//     // Steps animation - sequentially
//     const stepDelay = 1300;
    
//     steps.forEach((_, index) => {
//       setTimeout(() => {
//         setActiveStepIndex(index);
//       }, stepDelay + (index * 300)); // Each step appears after 300ms delay
//     });
//   }, []);
  
//   // Styles
//   const qualityProcessSection = {
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'space-between',
//     gap: '40px',
//     flexWrap: 'wrap',
//     padding: '20px',
//     maxWidth: '1000px',
//     margin: '0 auto',
//     fontFamily: 'system-ui, sans-serif',
//   };
  
//   const titleSection = {
//     opacity: titleAnimated ? 1 : 0,
//     transform: titleAnimated ? 'translateY(0)' : 'translateY(20px)',
//     transition: 'all 0.6s ease-out',
//   };
  
//   const policyHeader = {
//     fontSize: '2.5rem',
//     background: 'linear-gradient(to right, #003366, rgb(255, 120, 0))',
//     WebkitBackgroundClip: 'text',
//     WebkitTextFillColor: 'transparent',
//     fontWeight: 'bold',
//     lineHeight: '1.2',
//     margin: '0 0 20px 0',
//   };
  
//   // Circle with continuous animation
//   const circleWrapper = {
//     width: '160px',
//     height: '160px',
//     borderRadius: '50%',
//     background: 'linear-gradient(135deg, #e6f0fa, #fff5ee)',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
//     border: '4px solid transparent',
//     borderImage: 'linear-gradient(45deg, #003366, rgb(255, 120, 0)) 1',
//     opacity: circleAnimated ? 1 : 0,
//     transform: circleAnimated ? 'scale(1) rotate(0deg)' : 'scale(0.5) rotate(-45deg)',
//     transition: 'all 0.7s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
//     position: 'relative',
//     overflow: 'hidden',
//   };
  
//   // Pulsing background effect
//   const pulsingCircleStyle = {
//     position: 'absolute',
//     top: '0',
//     left: '0',
//     width: '100%',
//     height: '100%',
//     borderRadius: '50%',
//     background: 'repeating-radial-gradient(circle, rgba(0, 51, 102, 0.1) 0%, rgba(255, 120, 0, 0.1) 20%, transparent 40%)',
//     animation: circleAnimated ? 'pulse 2s infinite' : 'none',
//   };
  
//   // Rotating outer ring effect
//   const rotatingRingStyle = {
//     position: 'absolute',
//     top: '-10px',
//     left: '-10px',
//     right: '-10px',
//     bottom: '-10px',
//     background: 'linear-gradient(45deg, transparent, transparent 49%, #003366 49%, #003366 51%, transparent 51%, transparent)',
//     backgroundSize: '20px 20px',
//     borderRadius: '50%',
//     opacity: 0.4,
//     animation: circleAnimated ? 'rotate 8s linear infinite' : 'none',
//   };
  
//   const qualityProcessWrapper = {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '12px',
//     minWidth: '300px',
//     flex: 1,
//   };
 
//   const qualityStep = {
//     backgroundColor: 'rgb(255, 120, 0)',
//     color: 'white',
//     padding: '12px 25px',
//     borderRadius: '50px',
//     fontSize: '15px',
//     fontWeight: '500',
//     boxShadow: '0 3px 6px rgba(0, 0, 0, 0.1)',
//     transition: 'all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
//     cursor: 'pointer',
//     whiteSpace: 'nowrap',
//     textAlign: 'center',
//   };

//   // Step hover effect
//   const [hoveredStep, setHoveredStep] = useState(null);
  
//   // Animation delays for steps with alternating colors
//   // const steps = [
//   //   { text: 'Production Plan Approval Process', marginLeft: '0px', color: 'rgb(255, 120, 0)' },
//   //   { text: 'PPAP New Parts', marginLeft: '30px', color: '#003366' },
//   //   { text: 'Control Plan', marginLeft: '50px', color: 'rgb(255, 120, 0)' },
//   //   { text: 'Failure Mode Effect Analysis', marginLeft: '60px', color: '#003366' },
//   //   { text: 'Poke Yoke', marginLeft: '80px', color: 'rgb(255, 120, 0)' },
//   //   { text: 'Statistical Process Control', marginLeft: '60px', color: '#003366' },
//   //   { text: '8D Approach Problem Solving', marginLeft: '50px', color: 'rgb(255, 120, 0)' },
//   //   { text: 'Final Inspection', marginLeft: '30px', color: '#003366' },
//   //   { text: 'Total Quality Maintenance', marginLeft: '0px', color: 'rgb(255, 120, 0)' },
//   // ];
//   const steps = [
//     { text: 'Production Plan Approval Process', marginLeft: '0px', color: 'rgb(255, 120, 0)' },
//     { text: 'PPAP New Parts', marginLeft: '20px', color: '#003366' },
//     { text: 'Control Plan', marginLeft: '40px', color: 'rgb(255, 120, 0)' },
//     { text: 'Failure Mode Effect Analysis', marginLeft: '60px', color: '#003366' },
//     { text: 'Poke Yoke', marginLeft: '80px', color: 'rgb(255, 120, 0)' },
//     { text: 'Statistical Process Control', marginLeft: '60px', color: '#003366' },
//     { text: '8D Approach Problem Solving', marginLeft: '40px', color: 'rgb(255, 120, 0)' },
//     { text: 'Final Inspection', marginLeft: '20px', color: '#003366' },
//     { text: 'Total Quality Maintenance', marginLeft: '0px', color: 'rgb(255, 120, 0)' },
//   ];
  
  

//   return (
//     <div style={qualityProcessSection}>
//       {/* CSS for animations */}
//       <style>
//         {`
//           @keyframes pulse {
//             0% { transform: scale(0.95); opacity: 0.7; }
//             50% { transform: scale(1.05); opacity: 0.9; }
//             100% { transform: scale(0.95); opacity: 0.7; }
//           }
          
//           @keyframes rotate {
//             0% { transform: rotate(0deg); }
//             100% { transform: rotate(360deg); }
//           }
          
//           @keyframes fadeInOut {
//             0% { opacity: 0; transform: translateX(-40px); }
//             10% { opacity: 1; transform: translateX(0); }
//             90% { opacity: 1; transform: translateX(0); }
//             100% { opacity: 0; transform: translateX(-40px); }
//           }
//         `}
//       </style>
    
//       <div style={titleSection} key={`title-${restartAnimation}`}>
//         <h2 style={policyHeader}>Quality <br/> Process</h2>
//       </div>
      
//       <div style={circleWrapper} key={`circle-${restartAnimation}`}>
//         <div style={rotatingRingStyle}></div>
//         <div style={pulsingCircleStyle}></div>
//         <FcProcess size={60} color="#003366" strokeWidth={1.5} fill="rgb(255, 120, 0)" />
//       </div>
      
//       <div style={qualityProcessWrapper}>
//         {steps.map((step, index) => (
//           <div 
//             key={`${index}-${restartAnimation}`}
//             style={{
//               ...qualityStep,
//               marginLeft: step.marginLeft,
//               opacity: index <= activeStepIndex ? 1 : 0,
//               transform: index <= activeStepIndex 
//                 ? (hoveredStep === index ? 'translateX(10px) scale(1.05)' : 'translateX(0)')
//                 : 'translateX(-40px)',
//               backgroundColor: hoveredStep === index 
//                 ? (step.color === 'rgb(255, 120, 0)' ? 'rgb(255, 140, 40)' : '#0055a4') 
//                 : step.color,
//               boxShadow: hoveredStep === index 
//                 ? '0 6px 12px rgba(0, 0, 0, 0.15)' 
//                 : '0 3px 6px rgba(0, 0, 0, 0.1)',
//             }}
//             onMouseEnter={() => setHoveredStep(index)}
//             onMouseLeave={() => setHoveredStep(null)}
//           >
//             {step.text}
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

// import { useState, useEffect, useCallback } from 'react';

// export default function QualityProcess() {
//   // Animation states
//   const [activeStepIndex, setActiveStepIndex] = useState(-1);
//   const [circleAnimated, setCircleAnimated] = useState(false);
//   const [titleAnimated, setTitleAnimated] = useState(false);
//   const [restartAnimation, setRestartAnimation] = useState(false);
  
//   // Sequential animation
//   useEffect(() => {
//     // Initial animation
//     runFullAnimation();
    
//     // Set up continuous animation every 8 seconds
//     const intervalId = setInterval(() => {
//       runFullAnimation();
//     }, 8000);
    
//     return () => clearInterval(intervalId);
//   }, []);
  
//   // Function to run full animation sequence - memoized with useCallback
//   const runFullAnimation = useCallback(() => {
//     // Reset everything
//     setActiveStepIndex(-1);
//     setCircleAnimated(false);
//     setTitleAnimated(false);
//     setRestartAnimation(prev => !prev); // Toggle to restart animations
    
//     // Start sequence again
//     setTimeout(() => setTitleAnimated(true), 300);
//     setTimeout(() => setCircleAnimated(true), 800);
    
//     // Steps animation - sequentially
//     const stepDelay = 1300;
    
//     steps.forEach((_, index) => {
//       setTimeout(() => {
//         setActiveStepIndex(index);
//       }, stepDelay + (index * 300)); // Each step appears after 300ms delay
//     });
//   }, []);
  
//   // Styles
//   const qualityProcessSection = {
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'space-between',
//     gap: '40px',
//     flexWrap: 'wrap',
//     padding: '20px',
//     maxWidth: '1000px',
//     margin: '0 auto',
//     fontFamily: 'system-ui, sans-serif',
//   };
  
//   const titleSection = {
//     opacity: titleAnimated ? 1 : 0,
//     transform: titleAnimated ? 'translateY(0)' : 'translateY(20px)',
//     transition: 'all 0.6s ease-out',
//   };
  
//   const policyHeader = {
//     fontSize: '2.5rem',
//     background: 'linear-gradient(to right, #003366, rgb(255, 120, 0))',
//     WebkitBackgroundClip: 'text',
//     WebkitTextFillColor: 'transparent',
//     fontWeight: 'bold',
//     lineHeight: '1.2',
//     margin: '0 0 20px 0',
//   };
  
//   // Circle matching the blue design in the image
//   const circleWrapper = {
//     width: '160px',
//     height: '160px',
//     borderRadius: '50%',
//     background: '#1e4584',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
//     border: '4px solid #193a70',
//     opacity: circleAnimated ? 1 : 0,
//     transform: circleAnimated ? 'scale(1) rotate(0deg)' : 'scale(0.5) rotate(-45deg)',
//     transition: 'all 0.7s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
//     position: 'relative',
//     overflow: 'hidden',
//   };
  
//   // Pulsing background effect
//   const pulsingCircleStyle = {
//     position: 'absolute',
//     top: '0',
//     left: '0',
//     width: '100%',
//     height: '100%',
//     borderRadius: '50%',
//     background: 'radial-gradient(circle, rgba(255,255,255,0.15) 0%, rgba(255,255,255,0) 70%)',
//     animation: circleAnimated ? 'pulse 2s infinite' : 'none',
//   };
  
//   // Rotating outer ring effect (retained but adapted for blue color scheme)
//   const rotatingRingStyle = {
//     position: 'absolute',
//     top: '-10px',
//     left: '-10px',
//     right: '-10px',
//     bottom: '-10px',
//     background: 'linear-gradient(45deg, transparent, transparent 49%, #102a59 49%, #102a59 51%, transparent 51%, transparent)',
//     backgroundSize: '20px 20px',
//     borderRadius: '50%',
//     opacity: 0.4,
//     animation: circleAnimated ? 'rotate 8s linear infinite' : 'none',
//   };
  
//   const qualityProcessWrapper = {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '16px',
//     minWidth: '300px',
//     flex: 1,
//     position: 'relative',
//     marginLeft: '60px', // Add space for the curved layout
//   };
 
//   const qualityStep = {
//     backgroundColor: '#1e4584',  // Blue color matching the image
//     color: 'white',
//     padding: '12px 25px',
//     borderRadius: '50px',
//     fontSize: '15px',
//     fontWeight: '500',
//     boxShadow: '0 3px 6px rgba(0, 0, 0, 0.2)',
//     transition: 'all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
//     cursor: 'pointer',
//     whiteSpace: 'nowrap',
//     textAlign: 'center',
//     width: '300px',  // Fixed width for all steps
//   };

//   // Step hover effect
//   const [hoveredStep, setHoveredStep] = useState(null);
  
//   // Steps configured to create a curved pattern like in the image
//   const steps = [
//     { text: 'Production Plan Approval Process', transform: 'translateX(0px)' },
//     { text: 'Control Plan', transform: 'translateX(40px)' },
//     { text: 'Failure Mode Effect Analysis', transform: 'translateX(80px)' },
//     { text: 'Poke Yoke', transform: 'translateX(120px)' },
//     { text: 'Statistical Process Control', transform: 'translateX(80px)' },
//     { text: 'Final Inspection', transform: 'translateX(40px)' },
//     { text: 'Total Quality Maintenance', transform: 'translateX(0px)' },
//   ];

//   // Missing PPAP New Parts and 8D Approach... from original list but not in image

//   return (
//     <div style={qualityProcessSection}>
//       {/* CSS for animations */}
//       <style>
//         {`
//           @keyframes pulse {
//             0% { transform: scale(0.95); opacity: 0.7; }
//             50% { transform: scale(1.05); opacity: 0.9; }
//             100% { transform: scale(0.95); opacity: 0.7; }
//           }
          
//           @keyframes rotate {
//             0% { transform: rotate(0deg); }
//             100% { transform: rotate(360deg); }
//           }
          
//           @keyframes fadeInOut {
//             0% { opacity: 0; transform: translateX(-40px); }
//             10% { opacity: 1; transform: translateX(0); }
//             90% { opacity: 1; transform: translateX(0); }
//             100% { opacity: 0; transform: translateX(-40px); }
//           }
//         `}
//       </style>
    
//       <div style={titleSection} key={`title-${restartAnimation}`}>
//         <h2 style={policyHeader}>Quality <br/> Process</h2>
//       </div>
      
//       <div style={circleWrapper} key={`circle-${restartAnimation}`}>
//         <div style={rotatingRingStyle}></div>
//         <div style={pulsingCircleStyle}></div>
//         <div style={{
//           width: '70%',
//           height: '70%',
//           borderRadius: '50%',
//           border: '6px solid white',
//           opacity: '0.7'
//         }}></div>
//       </div>
      
//       <div style={qualityProcessWrapper}>
//         {steps.map((step, index) => (
//           <div 
//             key={`${index}-${restartAnimation}`}
//             style={{
//               ...qualityStep,
//               transform: index <= activeStepIndex 
//                 ? (hoveredStep === index 
//                   ? `${step.transform} scale(1.05)` 
//                   : step.transform)
//                 : `translateX(-40px)`,
//               opacity: index <= activeStepIndex ? 1 : 0,
//               backgroundColor: hoveredStep === index ? '#2a5cad' : '#1e4584',
//               boxShadow: hoveredStep === index 
//                 ? '0 6px 12px rgba(0, 0, 0, 0.25)' 
//                 : '0 3px 6px rgba(0, 0, 0, 0.2)',
//             }}
//             onMouseEnter={() => setHoveredStep(index)}
//             onMouseLeave={() => setHoveredStep(null)}
//           >
//             {step.text}
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

/////crt code

// import { useState, useEffect, useCallback } from 'react';
// import { CheckCircle, BarChart2, ClipboardCheck, AlertCircle, RefreshCw } from 'lucide-react';

// export default function QualityProcess() {
//   // Animation states
//   const [activeStepIndex, setActiveStepIndex] = useState(-1);
//   const [circleAnimated, setCircleAnimated] = useState(false);
//   const [titleAnimated, setTitleAnimated] = useState(false);
//   const [restartAnimation, setRestartAnimation] = useState(false);
  
//   // Sequential animation
//   useEffect(() => {
//     // Initial animation
//     runFullAnimation();
    
//     // Set up continuous animation every 8 seconds
//     const intervalId = setInterval(() => {
//       runFullAnimation();
//     }, 8000);
    
//     return () => clearInterval(intervalId);
//   }, []);
  
//   // Function to run full animation sequence - memoized with useCallback
//   const runFullAnimation = useCallback(() => {
//     // Reset everything
//     setActiveStepIndex(-1);
//     setCircleAnimated(false);
//     setTitleAnimated(false);
//     setRestartAnimation(prev => !prev); // Toggle to restart animations
    
//     // Start sequence again
//     setTimeout(() => setTitleAnimated(true), 300);
//     setTimeout(() => setCircleAnimated(true), 800);
    
//     // Steps animation - sequentially
//     const stepDelay = 1300;
    
//     steps.forEach((_, index) => {
//       setTimeout(() => {
//         setActiveStepIndex(index);
//       }, stepDelay + (index * 300)); // Each step appears after 300ms delay
//     });
//   }, []);
  
//   // Styles
//   const qualityProcessSection = {
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'space-between',
//     gap: '40px',
//     flexWrap: 'wrap',
//     padding: '20px',
//     maxWidth: '1000px',
//     margin: '0 auto',
//     fontFamily: 'system-ui, sans-serif',
//   };
  
//   const titleSection = {
//     opacity: titleAnimated ? 1 : 0,
//     transform: titleAnimated ? 'translateY(0)' : 'translateY(20px)',
//     transition: 'all 0.6s ease-out',
//   };
  
//   const policyHeader = {
//     fontSize: '2.5rem',
//     background: 'linear-gradient(to right, #003366, rgb(255, 120, 0))',
//     WebkitBackgroundClip: 'text',
//     WebkitTextFillColor: 'transparent',
//     fontWeight: 'bold',
//     lineHeight: '1.2',
//     margin: '0 0 20px 0',
//   };
  
//   // Circle matching the blue design in the image
//   const circleWrapper = {
//     width: '160px',
//     height: '160px',
//     borderRadius: '50%',
//     background: '#1e4584',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
//     border: '4px solid #193a70',
//     opacity: circleAnimated ? 1 : 0,
//     transform: circleAnimated ? 'scale(1) rotate(0deg)' : 'scale(0.5) rotate(-45deg)',
//     transition: 'all 0.7s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
//     position: 'relative',
//     overflow: 'hidden',
//   };
  
//   // Pulsing background effect
//   const pulsingCircleStyle = {
//     position: 'absolute',
//     top: '0',
//     left: '0',
//     width: '100%',
//     height: '100%',
//     borderRadius: '50%',
//     background: 'radial-gradient(circle, rgba(255,255,255,0.15) 0%, rgba(255,255,255,0) 70%)',
//     animation: circleAnimated ? 'pulse 2s infinite' : 'none',
//   };
  
//   // Rotating outer ring effect (retained but adapted for blue color scheme)
//   const rotatingRingStyle = {
//     position: 'absolute',
//     top: '-10px',
//     left: '-10px',
//     right: '-10px',
//     bottom: '-10px',
//     background: 'linear-gradient(45deg, transparent, transparent 49%, #102a59 49%, #102a59 51%, transparent 51%, transparent)',
//     backgroundSize: '20px 20px',
//     borderRadius: '50%',
//     opacity: 0.4,
//     animation: circleAnimated ? 'rotate 8s linear infinite' : 'none',
//   };
  
//   const qualityProcessWrapper = {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '16px',
//     minWidth: '300px',
//     flex: 1,
//     position: 'relative',
//     marginLeft: '60px', // Add space for the curved layout
//   };
 
//   const qualityStep = {
//     backgroundColor: '#1e4584',  // Blue color matching the image
//     color: 'white',
//     padding: '12px 25px',
//     borderRadius: '50px',
//     fontSize: '15px',
//     fontWeight: '500',
//     boxShadow: '0 3px 6px rgba(0, 0, 0, 0.2)',
//     transition: 'all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
//     cursor: 'pointer',
//     whiteSpace: 'nowrap',
//     textAlign: 'center',
//     width: '300px',  // Fixed width for all steps
//   };

//   // Step hover effect
//   const [hoveredStep, setHoveredStep] = useState(null);
  
//   // Steps configured to create a curved pattern like in the image with alternating colors
//   const steps = [
//     { text: 'Production Plan Approval Process', transform: 'translateX(0px)', color: 'rgb(255, 120, 0)' },
//     { text: 'Control Plan', transform: 'translateX(40px)', color: '#1e4584' },
//     { text: 'Failure Mode Effect Analysis', transform: 'translateX(80px)', color: 'rgb(255, 120, 0)' },
//     { text: 'Poke Yoke', transform: 'translateX(120px)', color: '#1e4584' },
//     { text: 'Statistical Process Control', transform: 'translateX(80px)', color: 'rgb(255, 120, 0)' },
//     { text: 'Final Inspection', transform: 'translateX(40px)', color: '#1e4584' },
//     { text: 'Total Quality Maintenance', transform: 'translateX(0px)', color: 'rgb(255, 120, 0)' },
//   ];

//   // Missing PPAP New Parts and 8D Approach... from original list but not in image

//   return (
//     <div style={qualityProcessSection}>
//       {/* CSS for animations */}
//       <style>
//         {`
//           @keyframes pulse {
//             0% { transform: scale(0.95); opacity: 0.7; }
//             50% { transform: scale(1.05); opacity: 0.9; }
//             100% { transform: scale(0.95); opacity: 0.7; }
//           }
          
//           @keyframes rotate {
//             0% { transform: rotate(0deg); }
//             100% { transform: rotate(360deg); }
//           }
          
//           @keyframes fadeInOut {
//             0% { opacity: 0; transform: translateX(-40px); }
//             10% { opacity: 1; transform: translateX(0); }
//             90% { opacity: 1; transform: translateX(0); }
//             100% { opacity: 0; transform: translateX(-40px); }
//           }
//         `}
//       </style>
    
//       <div style={titleSection} key={`title-${restartAnimation}`}>
//         <h2 style={policyHeader}>Quality <br/> Process</h2>
//       </div>
      
//       <div style={circleWrapper} key={`circle-${restartAnimation}`}>
//         <div style={rotatingRingStyle}></div>
//         <div style={pulsingCircleStyle}></div>
//         <div style={{
//           width: '70%',
//           height: '70%',
//           borderRadius: '50%',
//           border: '6px solid white',
//           opacity: '0.7',
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center'
//         }}>
//           <ClipboardCheck size={40} color="white" strokeWidth={2} />
//         </div>
//       </div>
      
//       <div style={qualityProcessWrapper}>
//         {steps.map((step, index) => (
//           <div 
//             key={`${index}-${restartAnimation}`}
//             style={{
//               ...qualityStep,
//               transform: index <= activeStepIndex 
//                 ? (hoveredStep === index 
//                   ? `${step.transform} scale(1.05)` 
//                   : step.transform)
//                 : `translateX(-40px)`,
//               opacity: index <= activeStepIndex ? 1 : 0,
//               backgroundColor: hoveredStep === index 
//                 ? (step.color === 'rgb(255, 120, 0)' ? 'rgb(255, 140, 40)' : '#2a5cad')
//                 : step.color,
//               boxShadow: hoveredStep === index 
//                 ? '0 6px 12px rgba(0, 0, 0, 0.25)' 
//                 : '0 3px 6px rgba(0, 0, 0, 0.2)',
//             }}
//             onMouseEnter={() => setHoveredStep(index)}
//             onMouseLeave={() => setHoveredStep(null)}
//           >
//             {step.text}
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }



// import { useState, useEffect, useCallback } from 'react';
// import { CheckCircle, BarChart2, ClipboardCheck, AlertCircle, RefreshCw } from 'lucide-react';

// export default function QualityProcess() {
//   // Animation states
//   const [activeStepIndex, setActiveStepIndex] = useState(-1);
//   const [circleAnimated, setCircleAnimated] = useState(false);
//   const [titleAnimated, setTitleAnimated] = useState(false);
//   const [restartAnimation, setRestartAnimation] = useState(false);
  
//   // Sequential animation
//   useEffect(() => {
//     // Initial animation
//     runFullAnimation();
    
//     // Set up continuous animation every 8 seconds
//     const intervalId = setInterval(() => {
//       runFullAnimation();
//     }, 8000);
    
//     return () => clearInterval(intervalId);
//   }, []);
  
//   // Function to run full animation sequence - memoized with useCallback
//   const runFullAnimation = useCallback(() => {
//     // Reset everything
//     setActiveStepIndex(-1);
//     setCircleAnimated(false);
//     setTitleAnimated(false);
//     setRestartAnimation(prev => !prev); // Toggle to restart animations
    
//     // Start sequence again
//     setTimeout(() => setTitleAnimated(true), 300);
//     setTimeout(() => setCircleAnimated(true), 800);
    
//     // Steps animation - sequentially
//     const stepDelay = 1300;
    
//     steps.forEach((_, index) => {
//       setTimeout(() => {
//         setActiveStepIndex(index);
//       }, stepDelay + (index * 300)); // Each step appears after 300ms delay
//     });
//   }, []);
  
//   // Styles
//   const qualityProcessSection = {
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'space-between',
//     gap: '40px',
//     flexWrap: 'wrap',
//     padding: '20px',
//     maxWidth: '1000px',
//     margin: '0 auto',
//     fontFamily: 'system-ui, sans-serif',
//   };
  
//   const titleSection = {
//     opacity: titleAnimated ? 1 : 0,
//     transform: titleAnimated ? 'translateY(0)' : 'translateY(20px)',
//     transition: 'all 0.6s ease-out',
//   };
  
//   const policyHeader = {
//     fontSize: '2.5rem',
//     color: '#003366',  // Single color for the heading
//     fontWeight: 'bold',
//     lineHeight: '1.2',
//     margin: '0 0 20px 0',
//   };
  
//   // Circle matching the blue design in the image
//   const circleWrapper = {
//     width: '160px',
//     height: '160px',
//     borderRadius: '50%',
//     background: '#1e4584',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'center',
//     boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
//     border: '4px solid #193a70',
//     opacity: circleAnimated ? 1 : 0,
//     transform: circleAnimated ? 'scale(1) rotate(0deg)' : 'scale(0.5) rotate(-45deg)',
//     transition: 'all 0.7s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
//     position: 'relative',
//     overflow: 'hidden',
//   };
  
//   // Pulsing background effect
//   const pulsingCircleStyle = {
//     position: 'absolute',
//     top: '0',
//     left: '0',
//     width: '100%',
//     height: '100%',
//     borderRadius: '50%',
//     background: 'radial-gradient(circle, rgba(255,255,255,0.15) 0%, rgba(255,255,255,0) 70%)',
//     animation: circleAnimated ? 'pulse 2s infinite' : 'none',
//   };
  
//   // Rotating outer ring effect (retained but adapted for blue color scheme)
//   const rotatingRingStyle = {
//     position: 'absolute',
//     top: '-10px',
//     left: '-10px',
//     right: '-10px',
//     bottom: '-10px',
//     background: 'linear-gradient(45deg, transparent, transparent 49%, #102a59 49%, #102a59 51%, transparent 51%, transparent)',
//     backgroundSize: '20px 20px',
//     borderRadius: '50%',
//     opacity: 0.4,
//     animation: circleAnimated ? 'rotate 8s linear infinite' : 'none',
//   };
  
//   const qualityProcessWrapper = {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: '16px',
//     minWidth: '300px',
//     flex: 1,
//     position: 'relative',
//     marginLeft: '60px', // Add space for the curved layout
//   };
 
//   const qualityStep = {
//     backgroundColor: '#1e4584',  // Blue color matching the image
//     color: 'white',
//     padding: '12px 25px',
//     borderRadius: '50px',
//     fontSize: '15px',
//     fontWeight: '500',
//     boxShadow: '0 3px 6px rgba(0, 0, 0, 0.2)',
//     transition: 'all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
//     cursor: 'pointer',
//     whiteSpace: 'nowrap',
//     textAlign: 'center',
//     width: '300px',  // Fixed width for all steps
//   };

//   // Step hover effect
//   const [hoveredStep, setHoveredStep] = useState(null);
  
//   // Steps configured with the full list and alternating colors
//   const steps = [
//     { text: 'Production Plan Approval Process', transform: 'translateX(0px)', color: 'rgb(255, 120, 0)' },
//     { text: 'PPAP New Parts', transform: 'translateX(20px)', color: '#003366' },
//     { text: 'Control Plan', transform: 'translateX(40px)', color: 'rgb(255, 120, 0)' },
//     { text: 'Failure Mode Effect Analysis', transform: 'translateX(60px)', color: '#003366' },
//     { text: 'Poke Yoke', transform: 'translateX(80px)', color: 'rgb(255, 120, 0)' },
//     { text: 'Statistical Process Control', transform: 'translateX(60px)', color: '#003366' },
//     { text: '8D Approach Problem Solving', transform: 'translateX(40px)', color: 'rgb(255, 120, 0)' },
//     { text: 'Final Inspection', transform: 'translateX(20px)', color: '#003366' },
//     { text: 'Total Quality Maintenance', transform: 'translateX(0px)', color: 'rgb(255, 120, 0)' },
//   ];

//   // Missing PPAP New Parts and 8D Approach... from original list but not in image

//   return (
//     <div style={qualityProcessSection}>
//       {/* CSS for animations */}
//       <style>
//         {`
//           @keyframes pulse {
//             0% { transform: scale(0.95); opacity: 0.7; }
//             50% { transform: scale(1.05); opacity: 0.9; }
//             100% { transform: scale(0.95); opacity: 0.7; }
//           }
          
//           @keyframes rotate {
//             0% { transform: rotate(0deg); }
//             100% { transform: rotate(360deg); }
//           }
          
//           @keyframes fadeInOut {
//             0% { opacity: 0; transform: translateX(-40px); }
//             10% { opacity: 1; transform: translateX(0); }
//             90% { opacity: 1; transform: translateX(0); }
//             100% { opacity: 0; transform: translateX(-40px); }
//           }
//         `}
//       </style>
    
//       <div style={titleSection} key={`title-${restartAnimation}`}>
//         <h2 style={policyHeader}>Quality <br/> Process</h2>
//       </div>
      
//       <div style={circleWrapper} key={`circle-${restartAnimation}`}>
//         <div style={rotatingRingStyle}></div>
//         <div style={pulsingCircleStyle}></div>
//         <div style={{
//           width: '70%',
//           height: '70%',
//           borderRadius: '50%',
//           border: '6px solid white',
//           opacity: '0.7',
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center'
//         }}>
//           <ClipboardCheck size={40} color="white" strokeWidth={2} />
//         </div>
//       </div>
      
//       <div style={qualityProcessWrapper}>
//         {steps.map((step, index) => (
//           <div 
//             key={`${index}-${restartAnimation}`}
//             style={{
//               ...qualityStep,
//               transform: index <= activeStepIndex 
//                 ? (hoveredStep === index 
//                   ? `${step.transform} scale(1.05)` 
//                   : step.transform)
//                 : `translateX(-40px)`,
//               opacity: index <= activeStepIndex ? 1 : 0,
//               backgroundColor: hoveredStep === index 
//                 ? (step.color === 'rgb(255, 120, 0)' ? 'rgb(255, 140, 40)' : '#2a5cad')
//                 : step.color,
//               boxShadow: hoveredStep === index 
//                 ? '0 6px 12px rgba(0, 0, 0, 0.25)' 
//                 : '0 3px 6px rgba(0, 0, 0, 0.2)',
//             }}
//             onMouseEnter={() => setHoveredStep(index)}
//             onMouseLeave={() => setHoveredStep(null)}
//           >
//             {step.text}
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

import { useState, useEffect, useCallback } from 'react';
import { ClipboardCheck } from 'lucide-react';

export default function QualityProcess() {
  // Animation states
  const [activeStepIndex, setActiveStepIndex] = useState(-1);
  const [circleAnimated, setCircleAnimated] = useState(false);
  const [titleAnimated, setTitleAnimated] = useState(false);
  const [restartAnimation, setRestartAnimation] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  
  // Check for mobile view on mount and window resize
  useEffect(() => {
    const checkForMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    // Initial check
    checkForMobile();
    
    // Add resize listener
    window.addEventListener('resize', checkForMobile);
    
    // Clean up
    return () => window.removeEventListener('resize', checkForMobile);
  }, []);
  
  // Sequential animation
  useEffect(() => {
    // Initial animation
    runFullAnimation();
    
    // Set up continuous animation every 8 seconds
    const intervalId = setInterval(() => {
      runFullAnimation();
    }, 8000);
    
    return () => clearInterval(intervalId);
  }, []);
  
  // Function to run full animation sequence - memoized with useCallback
  const runFullAnimation = useCallback(() => {
    // Reset everything
    setActiveStepIndex(-1);
    setCircleAnimated(false);
    setTitleAnimated(false);
    setRestartAnimation(prev => !prev); // Toggle to restart animations
    
    // Start sequence again
    setTimeout(() => setTitleAnimated(true), 300);
    setTimeout(() => setCircleAnimated(true), 800);
    
    // Steps animation - sequentially
    const stepDelay = 1300;
    
    steps.forEach((_, index) => {
      setTimeout(() => {
        setActiveStepIndex(index);
      }, stepDelay + (index * 300)); // Each step appears after 300ms delay
    });
  }, []);
  
  // Steps configured with the full list and alternating colors
  const steps = [
    { text: 'Production Plan Approval Process', transform: isMobile ? '0' : 'translateX(0px)', color: 'rgb(255, 120, 0)' },
    { text: 'PPAP New Parts', transform: isMobile ? '0' : 'translateX(20px)', color: '#003366' },
    { text: 'Control Plan', transform: isMobile ? '0' : 'translateX(40px)', color: 'rgb(255, 120, 0)' },
    { text: 'Failure Mode Effect Analysis', transform: isMobile ? '0' : 'translateX(60px)', color: '#003366' },
    { text: 'Poke Yoke', transform: isMobile ? '0' : 'translateX(80px)', color: 'rgb(255, 120, 0)' },
    { text: 'Statistical Process Control', transform: isMobile ? '0' : 'translateX(60px)', color: '#003366' },
    { text: '8D Approach Problem Solving', transform: isMobile ? '0' : 'translateX(40px)', color: 'rgb(255, 120, 0)' },
    { text: 'Final Inspection', transform: isMobile ? '0' : 'translateX(20px)', color: '#003366' },
    { text: 'Total Quality Maintenance', transform: isMobile ? '0' : 'translateX(0px)', color: 'rgb(255, 120, 0)' },
  ];

  // Step hover effect
  const [hoveredStep, setHoveredStep] = useState(null);
  
  // Responsive styles
  const qualityProcessSection = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: isMobile ? 'center' : 'space-between',
    gap: isMobile ? '20px' : '40px',
    flexDirection: isMobile ? 'column' : 'row',
    flexWrap: isMobile ? 'nowrap' : 'wrap',
    padding: isMobile ? '10px' : '20px',
    maxWidth: '1000px',
    margin: '0 auto',
    fontFamily: 'system-ui, sans-serif',
  };
  
  const titleSection = {
    opacity: titleAnimated ? 1 : 0,
    transform: titleAnimated ? 'translateY(0)' : 'translateY(20px)',
    transition: 'all 0.6s ease-out',
    textAlign: isMobile ? 'center' : 'left',
    width: isMobile ? '100%' : 'auto',
  };
  
  const policyHeader = {
    fontSize: isMobile ? '2rem' : '2.5rem',
    color: '#003366',
    fontWeight: 'bold',
    lineHeight: '1.2',
    margin: '0 0 20px 0',
  };
  
  const circleWrapper = {
    width: isMobile ? '120px' : '160px',
    height: isMobile ? '120px' : '160px',
    borderRadius: '50%',
    background: '#1e4584',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
    border: '4px solid #193a70',
    opacity: circleAnimated ? 1 : 0,
    transform: circleAnimated ? 'scale(1) rotate(0deg)' : 'scale(0.5) rotate(-45deg)',
    transition: 'all 0.7s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
    position: 'relative',
    overflow: 'hidden',
    margin: isMobile ? '0 auto' : '0',
  };
  
  const pulsingCircleStyle = {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(255,255,255,0.15) 0%, rgba(255,255,255,0) 70%)',
    animation: circleAnimated ? 'pulse 2s infinite' : 'none',
  };
  
  const rotatingRingStyle = {
    position: 'absolute',
    top: '-10px',
    left: '-10px',
    right: '-10px',
    bottom: '-10px',
    background: 'linear-gradient(45deg, transparent, transparent 49%, #102a59 49%, #102a59 51%, transparent 51%, transparent)',
    backgroundSize: '20px 20px',
    borderRadius: '50%',
    opacity: 0.4,
    animation: circleAnimated ? 'rotate 8s linear infinite' : 'none',
  };
  
  const qualityProcessWrapper = {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    minWidth: isMobile ? 'auto' : '300px',
    flex: 1,
    position: 'relative',
    marginLeft: isMobile ? '0' : '60px',
    width: isMobile ? '100%' : 'auto',
  };
 
  const qualityStep = {
    backgroundColor: '#1e4584',
    color: 'white',
    padding: isMobile ? '10px 15px' : '12px 25px',
    borderRadius: '50px',
    fontSize: isMobile ? '14px' : '15px',
    fontWeight: '500',
    boxShadow: '0 3px 6px rgba(0, 0, 0, 0.2)',
    transition: 'all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
    cursor: 'pointer',
    whiteSpace: isMobile ? 'normal' : 'nowrap',
    textAlign: 'center',
    width: isMobile ? '90%' : '300px',
    margin: isMobile ? '0 auto' : '0',
  };

  return (
    <div style={qualityProcessSection}>
      {/* CSS for animations */}
      <style>
        {`
          @keyframes pulse {
            0% { transform: scale(0.95); opacity: 0.7; }
            50% { transform: scale(1.05); opacity: 0.9; }
            100% { transform: scale(0.95); opacity: 0.7; }
          }
          
          @keyframes rotate {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          
          @keyframes fadeInOut {
            0% { opacity: 0; transform: translateX(-40px); }
            10% { opacity: 1; transform: translateX(0); }
            90% { opacity: 1; transform: translateX(0); }
            100% { opacity: 0; transform: translateX(-40px); }
          }
          
          @media (max-width: 768px) {
            @keyframes fadeInOut {
              0% { opacity: 0; transform: translateY(-20px); }
              10% { opacity: 1; transform: translateY(0); }
              90% { opacity: 1; transform: translateY(0); }
              100% { opacity: 0; transform: translateY(-20px); }
            }
          }
        `}
      </style>
    
      <div style={titleSection} key={`title-${restartAnimation}`}>
        <h2 style={policyHeader}>Quality <br/> Process</h2>
      </div>
      
      <div style={circleWrapper} key={`circle-${restartAnimation}`}>
        <div style={rotatingRingStyle}></div>
        <div style={pulsingCircleStyle}></div>
        <div style={{
          width: '70%',
          height: '70%',
          borderRadius: '50%',
          border: '6px solid white',
          opacity: '0.7',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <ClipboardCheck size={isMobile ? 30 : 40} color="white" strokeWidth={2} />
        </div>
      </div>
      
      <div style={qualityProcessWrapper}>
        {steps.map((step, index) => (
          <div 
            key={`${index}-${restartAnimation}`}
            style={{
              ...qualityStep,
              transform: index <= activeStepIndex 
                ? (hoveredStep === index 
                  ? (isMobile ? 'scale(1.05)' : `${step.transform} scale(1.05)`) 
                  : (isMobile ? 'translateX(0)' : step.transform))
                : (isMobile ? 'translateY(-20px)' : 'translateX(-40px)'),
              opacity: index <= activeStepIndex ? 1 : 0,
              backgroundColor: hoveredStep === index 
                ? (step.color === 'rgb(255, 120, 0)' ? 'rgb(255, 140, 40)' : '#2a5cad')
                : step.color,
              boxShadow: hoveredStep === index 
                ? '0 6px 12px rgba(0, 0, 0, 0.25)' 
                : '0 3px 6px rgba(0, 0, 0, 0.2)',
            }}
            onMouseEnter={() => setHoveredStep(index)}
            onMouseLeave={() => setHoveredStep(null)}
          >
            {step.text}
          </div>
        ))}
      </div>
    </div>
  );
}